import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, grey } from '@mui/material/colors';

// PermissionsMatrix.js

const groupDisplayNameMap = {
  CoursesAdminTeam: 'Courses Admin',
  StandardUser: 'Standard User',
  CommunityAdminTeam: 'Community Admin',
  // Add more as needed
};

const PermissionsMatrix = ({ permissions, currentRoleGroup, appLabel }) => {
  if (!permissions || permissions.length === 0) return null;

  // Only include groups that are actually used in this app
  const relevantGroups = new Set(['StandardUser']);
  permissions.forEach((perm) => {
    Object.entries(perm.groups || {}).forEach(([group, hasPermission]) => {
      if (hasPermission) {
        relevantGroups.add(group);
      }
    });
  });
  
  

  const columns = [
    {
      field: 'permission',
      headerName: 'Permission',
      width: 250,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
    },
    ...Array.from(relevantGroups).map((group) => {
      const isCurrent = group === currentRoleGroup;
      return {
        field: group,
        headerName: groupDisplayNameMap[group] || group,
        width: 150,
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
          <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
            {params.value ? (
              <CheckCircleIcon sx={{ color: green[500] }} />
            ) : (
              <CancelIcon sx={{ color: grey[400] }} />
            )}
          </Box>
        ),
        cellClassName: isCurrent ? 'highlighted-column' : 'inactive-column',
        headerClassName: isCurrent ? 'highlighted-column' : 'inactive-column',
      };
    }),
  ];

  const rows = permissions
    .filter((perm) => perm.app_label === appLabel)
    .map((perm, index) => ({
      id: index,
      permission: perm.permission_name,
      ...perm.groups,
    }));

  // [styling unchanged]
  const customStyles = {
    '& .highlighted-column': {
      backgroundColor: (theme) => theme.palette.action.selected,
      fontWeight: 600,
    },
    '& .inactive-column': {
      opacity: 0.5,
    },
    '& .MuiDataGrid-cell': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .MuiDataGrid-columnHeader': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
      textAlign: 'center',
      width: '100%',
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: 'transparent',
    },
  };

  return (
    <Box sx={{ width: '100%', mt: 2, ...customStyles }}>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        disableColumnMenu
        hideFooter
        rowHeight={48}
        columnHeaderHeight={48}
        disableSelectionOnClick
        disableRowSelectionOnClick
        checkboxSelection={false}
        sx={{ fontSize: 14, ...customStyles }}
      />
    </Box>
  );
};


export default PermissionsMatrix;
